export const contactInfo = {
  address: 'Bright Study, Karol Bagh, New Delhi, India',
  phone: '+91 8860080313',
  phoneHref: 'tel:+91886008031',
  email: 'hello@brightstudy.in',
  emailHref: 'mailto:hello@brightstudy.in',
  salesEmail: 'sales@brightstudy.in',
  salesEmailHref: 'mailto:sales@brightstudy.in',
  parentDesk: 'parents@brightstudy.in',
  parentDeskHref: 'mailto:parents@brightstudy.in',
};

export const socialLinks = [
  { label: 'Facebook', href: '#' },
  { label: 'Instagram', href: '#' },
  { label: 'LinkedIn', href: '#' },
  { label: 'X', href: '#' },
  { label: 'YouTube', href: '#' },
];

export const mainNav = [
  {
    label: 'Platforms',
    to: '/platforms',
    children: [
      { label: 'ERP', to: '/platforms/erp' },
      { label: 'LMS', to: '/platforms/lms' },
      { label: 'Website', to: '/platforms/website' },
      { label: 'AI', to: '/platforms/ai' },
      { label: 'AI Analytics Dashboard', to: '/platforms/ai-analytics-dashboard' },
      { label: 'Mobile Application', to: '/platforms/mobile-application' },
    ],
  },
  {
    label: 'School Optimisation',
    to: '/school-optimisation',
    children: [
      { label: 'Administration', to: '/school-optimisation/administration' },
      { label: 'Finance', to: '/school-optimisation/finance' },
      { label: 'Learning', to: '/school-optimisation/learning' },
      { label: 'Academics', to: '/school-optimisation/academics' },
      { label: 'Intelligence', to: '/school-optimisation/intelligence' },
      { label: 'Logistics', to: '/school-optimisation/logistics' },
      { label: 'Leadership / Management', to: '/school-optimisation/leadership-management' },
      { label: 'Enterprise Features', to: '/school-optimisation/enterprise-features' },
      { label: 'Communication', to: '/school-optimisation/communication' },
      { label: 'Human Resources', to: '/school-optimisation/human-resources' },
    ],
    dropdownCta: {
      label: 'Explore Automation',
      to: '/school-optimisation/explore-automation',
    },
  },
  {
    label: 'Success Stories',
    to: '/success-stories',
    children: [
      { label: 'Case Studies', to: '/success-stories/case-studies' },
    ],
  },
  {
    label: 'Insights',
    to: '/insights',
    children: [
      { label: 'Coverage', to: '/insights/coverage' },
      { label: 'Video', to: '/insights/video' },
      { label: 'Ed Talks', to: '/insights/ed-talks' },
      { label: 'Blogs', to: '/insights/blogs' },
      { label: 'Newsletter', to: '/insights/newsletter' },
      { label: 'Student Zone', to: '/insights/student-zone' },
      { label: 'Educator Zone', to: '/insights/educator-zone' },
      { label: 'Educators Article', to: '/insights/educators-article' },
    ],
  },
  {
    label: 'About Us',
    to: '/about-us',
    children: [
      { label: 'Company', to: '/about-us/company' },
      { label: 'Leadership', to: '/about-us/leadership' },
      { label: 'Partners', to: '/about-us/partners' },
      { label: 'Awards', to: '/about-us/awards' },
    ],
  },
  {
    label: 'Contact Us',
    to: '/contact-us',
    children: [
      { label: 'Connect With Us', to: '/contact-us/connect-with-us' },
      { label: 'Apply As A Speaker', to: '/contact-us/apply-as-a-speaker' },
      { label: 'Career', to: '/contact-us/career' },
    ],
  },
];

export const demoPage = {
  label: 'Register for Demo',
  to: '/register-for-demo',
  parent: 'Bright Study',
};

export const pricingPage = {
  label: 'Pricing',
  to: '/pricing',
  parent: 'Bright Study',
};

function flattenNavPages() {
  const pages = [demoPage];

  mainNav.forEach((item) => {
    pages.push({ label: item.label, to: item.to, parent: 'Bright Study' });
    item.children?.forEach((child) => {
      pages.push({ label: child.label, to: child.to, parent: item.label });
    });
    if (item.dropdownCta) {
      pages.push({
        label: item.dropdownCta.label,
        to: item.dropdownCta.to,
        parent: item.label,
      });
    }
  });

  return pages;
}

export const comingSoonPages = flattenNavPages().filter(
  (page) => page.to !== '/register-for-demo' && page.to !== '/pricing'
);

export const footerColumns = {
  platforms: mainNav[0].children,
  optimisation: mainNav[1].children.slice(0, 5),
  insights: mainNav[3].children.slice(0, 5),
  company: [
    { label: 'About Us', to: '/about-us' },
    { label: 'Pricing', to: '/pricing' },
    { label: 'Success Stories', to: '/success-stories' },
    { label: 'Contact Us', to: '/contact-us' },
    { label: 'Career', to: '/contact-us/career' },
    { label: 'Privacy Policy', to: '/privacy-policy' },
  ],
};

export function isNavItemActive(pathname, item) {
  if (pathname === item.to) return true;
  if (pathname.startsWith(`${item.to}/`)) return true;
  return item.children?.some((child) => pathname === child.to) || false;
}
